import { Languages, Menu } from 'lucide-react';
import { IconButton, Sep } from '@/components/ui';
import { useI18n } from '@/i18n';
import { useOptionalApp } from '@/lib/auth/app-context';
import { useFormat } from '@/lib/format/useFormat';
import { UserMenu } from './UserMenu';

export function Topbar({ onMenu, slotRef }: { onMenu: () => void; slotRef: (el: HTMLElement | null) => void }) {
  const { t } = useI18n();
  const school = useOptionalApp()?.school;
  const fmt = useFormat();
  return (
    <header className="sticky top-0 z-20 flex min-h-[72px] items-center gap-2 border-b border-line bg-raised/95 px-4 py-3 backdrop-blur-sm sm:gap-4 sm:px-8 print:hidden">
      <IconButton icon={Menu} label={t('common.openMenu')} onClick={onMenu} className="-ms-2 lg:hidden" />
      <div ref={slotRef} className="flex min-w-0 flex-1" />
      <div className="flex shrink-0 items-center gap-1 sm:gap-2">
        {school ? (
          <span className="hidden rounded-sm bg-track px-2.5 py-1 text-sm text-muted 2xl:inline">
            {t(`country.${school.country}`)}
            <Sep />
            {fmt.symbol}
            {school.currentYear ? (
              <>
                <Sep />
                {fmt.digits(school.currentYear.name)}
              </>
            ) : null}
          </span>
        ) : null}
        <LanguageToggle />
        <UserMenu />
      </div>
    </header>
  );
}

export function LanguageToggle() {
  const { t, lang, setLang } = useI18n();
  return (
    <button
      type="button"
      onClick={() => void setLang(lang === 'ar' ? 'en' : 'ar')}
      lang={lang === 'ar' ? 'en' : 'ar'}
      aria-label={`${t('common.languageLabel')}: ${t('common.language')}`}
      className="inline-flex h-11 items-center gap-1.5 rounded-md px-2.5 text-sm text-muted transition-colors hover:bg-track hover:text-ink"
    >
      <Languages aria-hidden className="size-[18px]" />
      <span className="hidden sm:inline">{t('common.language')}</span>
    </button>
  );
}
